export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s לא נבחר';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s לא יכול/ים להיות ריקים';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s חובה';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s לא מולאו נכון';
                break;

            case 'opt-in':
                translation = '[שדה(ים)] אנא סמן את התיבה כדי להמשיך';
                break;

            default:
                translation = 'שדה לא מולא כהלכה';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = 'לא נמצאו תוצאות';
                break;

            case 'address-not-checked':
                translation = 'גרור את המפה  ושחרר את הפין על הבית שלך';
                break;

            default:
                translation = 'אראה שגיאה';
                break;
        }

        return translation;
    }
}
